import styled from 'styled-components'
import { theme } from '@dasa-health/components-react'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100dvh;
    background-color: #fff;
    padding: 1rem;
    max-width: 27rem;
    margin: 0 auto;
`

export const MessageContainer = styled.div`
    margin-top: 1rem;
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
    @media screen and (min-width: ${theme.breakpoints[1]}) {
        flex: 1;
        justify-content: flex-end;
        padding-bottom: 1.5rem;
    }
`

export const ButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    @media screen and (min-width: ${theme.breakpoints[1]}) {
        flex: 1;
        justify-content: flex-start;
        padding-top: 1.5rem;
    }
`

export const Title = styled.h1`
    font-weight: bold;
    margin-bottom: 1rem;
    text-align: center;
    color: #161616;
    font-size: 1.25rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1.5rem;
`

export const Message = styled.p`
    text-align: center;
    color: #666;
    font-size: 1rem;
    font-style: normal;
    font-weight: normal;
    line-height: 1.5rem;
`

export const Illustration = styled.img`
    margin-bottom: 2.5rem;
`
